import environment from "@environment";
import axios from "axios";



// export const ServiceBase = axios.create({
//   baseURL: "http://localhost:5000/api/",
//   // timeout:1
//   // baseURL: "http://icfc.guiadocondutor.com.br:5000/api/"
// });

export const Post = async  <T>(url: string, data: any) => {
  let result = await ServiceBase.instance.post<T>(url, data);
  return result.data;
};

export const Get = async  <T>(url: string) => {
  const result = await ServiceBase.instance.get<T>(url);
  if (!result.status ) throw 'Erro api'
  return result.data;
};

export const Delete = async  <T>(url: string) => {
  const result = await ServiceBase.instance.delete<T>(url);
  if (!result.status || result.status != 200) throw 'Erro api'
  return result.data;
};


console.log('ServiceBase',environment.url_api_infra_service);

export class ServiceBase {
  
  static instance = axios.create({
    baseURL: environment.url_api_infra_service+"api/",
    withCredentials:false,
    headers: {"Access-Control-Allow-Origin": "*",
      'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }

    // timeout:1
    // baseURL: "http://icfc.guiadocondutor.com.br:5000/api/"
  });



}

